import React, { useState, useEffect } from 'react';
import { Spin, message, Table, Select } from 'antd';
import { getInfocultivostranper, Infocomponenteeconomico, vocacionagricola } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LogarithmicScale } from 'chart.js';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LogarithmicScale
);

const { Option } = Select;

const ComponenetAgro = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [DescripciónAgro, setAgro] = useState('');
    const [Agricola, setDataAgri] = useState([]);
    const [componente, setComponente] = useState('');
    const [fuente, setFuente] = useState('');
    const [year, setYear] = useState('2017');
    const [years, setYears] = useState([]);
    const [cultivosPermanentes, setCultivosPermanentes] = useState([]);
    const [cultivosTransitorios, setCultivosTransitorios] = useState([]);

    useEffect(() => {
        if (municipioId) {
            fetchDataCEconomico();
            Vocacionagricola();
            cultivos();
        }
    }, [municipioId]);

    const fetchDataCEconomico = async () => {
        setLoading(true);
        try {
            const response = await Infocomponenteeconomico(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setData(fetchedData);
                if (Array.isArray(fetchedData) && fetchedData.length > 0) {
                    setAgro(fetchedData[0].comp_agropecuario);
                    setFuente(fetchedData[0].fuente_pec);
                    setComponente(fetchedData[0].nombre_componente);
                } else {
                    throw new Error('Fetched data is not an array or is empty');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const Vocacionagricola = async () => {
        setLoading(true);
        try {
            const response = await vocacionagricola(municipioId);
            if (response && response.status === 200) {
                const dataAgricola = response.data;
                setDataAgri(dataAgricola);

                if (dataAgricola.length > 0) {
                    const sampleData = dataAgricola[0];
                    const yearsExtracted = Object.keys(sampleData)
                        .filter(key => key.startsWith('as_'))
                        .map(key => key.split('_')[1]);
                    setYears(yearsExtracted);
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const cultivos = async () => {
        setLoading(true);
        try {
            const response = await getInfocultivostranper(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    const permanentes = fetchedData.filter(cultivo => cultivo.tipo_cultivo === 'permanente');
                    const transitorios = fetchedData.filter(cultivo => cultivo.tipo_cultivo === 'transitorio');
                    setCultivosPermanentes(permanentes);
                    setCultivosTransitorios(transitorios);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const backgroundColors = [
        'rgba(255, 99, 132, 1)', // Rojo
        'rgba(54, 162, 235, 1)', // Azul
        'rgba(255, 206, 86, 1)', // Amarillo
        'rgba(75, 192, 192, 1)', // Verde
        'rgba(153, 102, 255, 1)', // Violeta
        'rgba(255, 159, 64, 1)', // Naranja
    ];
    const getChartData = (cultivos) => {
        const labels = cultivos.map(cultivo => cultivo.linea);
        const data = cultivos.map(cultivo => cultivo.tn);

        return {
            labels,
            datasets: [
                {
                    label: 'Cultivos',
                    data: data,
                    backgroundColor: backgroundColors.slice(0, data.length), // Asigna colores según la cantidad de barras
                }

            ],
        };
    };

    const chartOptions = {
        scales: {
            y: {
                type: 'logarithmic',
                ticks: {
                    callback: function (value) {
                        return value.toLocaleString(); // Better visualization of numbers
                    }
                },
                min: 0, // Valor mínimo visible en el eje Y (puedes ajustarlo según tus necesidades)
                max: 1000000,
            }
        }
    };

    const handleYearChange = (value) => {
        setYear(value);
    };

    const columnsPermanentes = [
        {
            title: 'Línea Productiva',
            dataIndex: 'linea',
            key: 'linea',
            className: 'filaP'
        },
        {
            title: 'Toneladas',
            dataIndex: 'tn',
            key: 'tn',
            className: 'filaP'
        }
    ];

    const columnsTransitorios = [
        {
            title: 'Línea Productiva',
            dataIndex: 'linea',
            key: 'linea',
            className: 'filaP'
        },
        {
            title: 'Toneladas',
            dataIndex: 'tn',
            key: 'tn',
            className: 'filaP'
        }
    ];

    const columns = [
        {
            title: 'Línea Productiva',
            dataIndex: 'linea_productiva',
            key: 'linea_productiva',
            className: 'filaP'
        },
        { title: `Área Sembrada`, dataIndex: `as_${year}`, key: `as_${year}`, className: 'filaP' },
        {
            title: `Área Cosechada`,
            dataIndex: `ac_${year}`,
            key: `ac_${year}`,
            className: 'filaP'
        },
        {
            title: `Producción`,
            dataIndex: `p_${year}`,
            key: `p_${year}`,
            className: 'filaP'
        },
    ];

    return (
        <div className="page-content">

            <h3>5. COMPONENTE AGROPECUARIO</h3>
            <p className="descripcion"><strong>Componente:</strong> {componente}</p>
            <p className="descripcion"><strong>Descripción Agropecuaria:</strong> {DescripciónAgro}</p>
            <p className="descripcion"><strong>Fuente de Información:</strong> {fuente}</p>

            <Select defaultValue={year} onChange={handleYearChange} style={{ width: 120, marginRight: 10 }}>
                {years.map(year => (
                    <Option key={year} value={year}>{year}</Option>
                ))}
            </Select>

            {Agricola.length > 0 ? (
                <Table dataSource={Agricola} columns={columns} rowKey="idvocacion" />
            ) : (
                <p>No hay datos agrícolas disponibles para este municipio.</p>
            )}

            <div className="content-cultivos">
                <div>
                    <h4>Cultivos Permanentes</h4>
                    {cultivosPermanentes.length > 0 ? (
                        <>
                            <Table dataSource={cultivosPermanentes} columns={columnsPermanentes} rowKey="idcultivo" />
                            <div style={{ marginTop: '20px', width: '100%' }}>
                                <Bar
                                    data={getChartData(cultivosPermanentes)}
                                    options={chartOptions}
                                />

                            </div>
                        </>
                    ) : (
                        <p>No hay datos de cultivos permanentes disponibles para este municipio.</p>
                    )}
                </div>


                <div>
                    <h4>Cultivos Transitorios</h4>
                    {cultivosTransitorios.length > 0 ? (
                        <>
                            <Table dataSource={cultivosTransitorios} columns={columnsTransitorios} rowKey="idcultivo" />
                            <div style={{ marginTop: '20px', width: '100%' }}>
                                <Bar data={getChartData(cultivosTransitorios)} options={chartOptions} />
                            </div>
                        </>
                    ) : (
                        <p>No hay datos de cultivos transitorios disponibles para este municipio.</p>
                    )}
                </div>
            </div>
        </div >
    );
};

export default ComponenetAgro;
